<div *ngIf="step && !isLoading()" class="user-to-groups">
  <div class="group">Select groups</div>

  <div class="group-list add_user">
    <div class="group-list-item">
      <!-- <md-checkbox ng-checked="step.isAllSelected('groupIds')" aria-label="group selection"></md-checkbox> -->
      <!-- Do not try to 'fix' the problem, when Select All checkbox is disabled as unchecked - even if you clicked it to be checked.
        Why? There will be at least one group that you can not remove the user from. Therefore the 'isAllSelected' will always return false. -->
      <mat-checkbox
        color="primary"
        aria-label="group selection"
        class="selectedcheckBox"
        [checked]="selectedAll.isChecked"
        (click)="flipValues();clickDetected($event);"
      ></mat-checkbox>
      <div>Select all</div>
    </div>
    <!-- [captureOutput]="step._returnOutput('groupIds', step.dataSource, null, { isChecked: true })" -->
    <div
      class="group-list-item"
      *ngFor="let group of grouplist; let isOdd = odd"
      [attr.disabled]="group.disabled"
      [ngClass]="[isOdd ? 'stripped' : '', group.disabled ? 'disabledListItem'  : '']"
    >
      <ng-container *ngIf="!group.hidden">
        <!-- <md-checkbox ng-disabled="group.disabled" ng-checked="group.isChecked" aria-label="group selection"></md-checkbox> -->
        <mat-checkbox
          color="primary"
          *ngIf="!group.disabled"
          class="selectedcheckBox"
          [checked]="group.isChecked"
          aria-label="group selection"
          (click)="flipValue(group);clickDetected($event);"
        ></mat-checkbox>
        <div>{{group.name}}</div>
        <div class="smaller" *ngIf="group.disabled">
          Administrators cannot remove themselves from this group.
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div *ngIf="isLoading()" class="loader">
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
